export const Stage = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         width="18"
         height="16"
         viewBox="0 0 18 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <rect width="18" height="4" rx="2" fill="currentColor" />
         <rect y="6" width="18" height="4" rx="2" fill="currentColor" />
         <rect y="12" width="18" height="4" rx="2" fill="currentColor" />
      </svg>
   )
}
